module.exports = __webpack_public_path__ + "static/2025-77933a9a8445011d15e6a465bbb0eb7c.png";